import React from "react";
import SVGInline from "react-svg-inline";

/* eslint import/no-webpack-loader-syntax: off */
import logoObersoundSVG from "!raw-loader!../images/logos/logo-obersound.svg";
import editorPreviewBg from "../images/editor-preview-bg-1920x1080.jpg";
import { surfaceBrandsByIds } from "../constants/surfaceBrands";
import { patternCollectionsByIds } from "../constants/patternCollections";
import { patternsByIds } from "../constants/patterns";
import { surfacesByIds } from "../constants/surfaces";
import Pattern from "./Pattern";
import ModelExportDescription from "./ModelExportDescription";
import ModelExportAcousticPerf from "./ModelExportAcousticPerf";
import ModelExportFooter from "./ModelExportFooter";

const ModelExportPdf = props => {
  const { modelExport, t } = props;
  const {
    id,
    surfaceId,
    patternId,
    patternConfig,
    userFullname,
    userCompany,
    folderTitle
  } = modelExport || {};

  const today = new Date();
  const dd = today.getDate();
  const mm = today.getMonth() + 1;
  const yyyy = today.getFullYear();
  const date = `${dd < 10 ? "0" + dd : dd}.${mm < 10 ? "0" + mm : mm}.${yyyy}`;
  const dateString = `${yyyy}${mm}${dd}`;
  const surface = surfacesByIds[surfaceId];
  const surfaceBrand = surfaceBrandsByIds[surface.brandId];
  const pattern = patternsByIds[patternId];


  //  COMPOSER / COMPOSE Adding specific ref for personalized pattern to the pdf reference
      if (patternId ===0) {   // COMPOSER / COMPOSE

        var holesArrayByDefault = {1:2, 2:2, 3:2, 4:2, 5:2, 6:2, 7:2, 8:2, 9:2 };  //9 holes array 2 pour activé; 1 pour désactivé
        var myHole = 2;
        for (const [key] of Object.entries(holesArrayByDefault)) {
          myHole = 2;
          if (patternConfig[pattern.configs_ref[key-1]] === true) { // Convert to OBERSOUND data reference
            myHole = 1;
          }
          pattern.ref += myHole;
        }
      }

//  GRAISSER / GREASE Adding specific ref for personalized pattern to the pdf reference
    else if (patternId ===8) {   // GREASE GRAISSER
      for (const [value] of Object.entries(patternConfig)) {
//        console.log(key, pattern.configs_ref[patternConfig[value]]);
        pattern.ref += pattern.configs_ref[patternConfig[value]];
      }
    }

  // Adding specific ref for personalized pattern to the pdf reference
   else if (pattern.configs_ref && pattern.configs_ref[patternConfig["index"]]["diameter_ref"] && pattern.configs_ref[patternConfig['index']]["spacing_ref"][patternConfig['spacingIndex']]){
    pattern.ref += pattern.configs_ref[patternConfig["index"]]["diameter_ref"];
    pattern.ref += pattern.configs_ref[patternConfig['index']]["spacing_ref"][patternConfig['spacingIndex']];

  } else if (pattern.configs_ref && pattern.configs) {
    pattern.ref += pattern.configs_ref[patternConfig["index"]];
/*
    console.log("------");
    console.log(pattern.configs);
    console.log("------");

    console.log(pattern.ref);
    console.log(patternConfig);
    console.log(pattern.configs_ref[patternConfig["index"]]);
    console.log("------");
*/
  }


  const patternCollection = patternCollectionsByIds[pattern.collectionId];
  const ref = [
    surfaceBrand.codeBrand,
    surface.ref,
    pattern.ref,
    dateString,
  ].join("-");


  return (
    <div className="js-puppeteer" style={{ width: "800px" }}>
      <div className="pa4 pdf">
        <header className="relative flex items-center pb-max mb1 bb">
          <div className="w-50">
            <div className="f1 b">
              <SVGInline height={"54px"} svg={logoObersoundSVG} />
            </div>
            <div className="w-202 tr">{t("pdf:pdfLogoTitle")}</div>
          </div>
          <div className="w-50 tr">
            <div className="fw4 tracked mb2">{t("pdf:pdfProductSpec")}</div>
            <div className="dib pv1 ph1 f-min ba br-pill">
              www.obersound.com
            </div>
          </div>
        </header>
        <div className="f4 b mb2">{t("pdf:pdfProductRef")} {ref}</div>
        <div className="flex f7 mb4">
          <div className="w-50 mr2">
            <div className="mb02">
              <span className="b">{t("pdf:pdfLabelName")}</span> {userFullname}
            </div>
            <div className="mb2">
              <span className="b">{t("pdf:pdfLabelCompany")}</span>{" "}
              {userCompany}
            </div>
            <div className="flex">
              <div className="w-50 mr2 ba">
                <div className="h-200 overflow-hidden">
                  <img src={surface.imageThumbnail} alt="" />
                </div>
                <div className="h-200 overflow-hidden bt">
                  <Pattern
                    keySeed={id}
                    config={patternConfig}
                    pattern={pattern}
                    scaled
                  />
                </div>
              </div>
              <div
                className="w-50 ba relative flex items-center"
                style={{
                  backgroundImage: `url(${editorPreviewBg})`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPositionX: "50%"
                }}
              >
                <div className="w-50 h-100 mt7 center">
                      <div className="h-75 relative">
                          <div className="h-100 overflow-hidden relative">
                              <div className="w-100 absolute" style={{ zIndex: 1 }}>
                                  <img src={surface.imageThumbnail} alt="" />
                              </div>
                              <div className="absolute w-100 h-100" style={{ zIndex: 2 }}>
                                  <Pattern
                                    keySeed={id}
                                    config={patternConfig}
                                    pattern={pattern}
                                    pdfexportsmallscale
                                  />
                              </div>
                          </div>
                          <div className="editor-preview__ladder">
                            <div className="editor-preview__ladder-label">
                              {"2500 mm"}
                            </div>
                          </div>
                      </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-50">
            <div className="mb02">
              <span className="b">{t("pdf:pdfLabelFolderName")}</span>{" "}
              {folderTitle}
            </div>
            <div className="mb2">
              <span className="b">{t("pdf:pdfLabelDate")}</span> {date}
            </div>
            <div className="h-200 overflow-hidden ba h-400 relative">
              <div className="absolute" style={{ zIndex: 1 }}>
                <img src={surface.imageThumbnail} alt="" />
              </div>
              <div className="absolute w-100 h-100" style={{ zIndex: 2 }}>
                <Pattern
                  keySeed={id}
                  config={patternConfig}
                  pattern={pattern}
                  scaled
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex mb2 pb4 bb">
          <div className="w-50 bt pt2 mr2">
            <ModelExportDescription
              t={t}
              surfaceBrand={surfaceBrand}
              surface={surface}
              pattern={pattern}
              patternCollectionTitle={patternCollection.title}
              patternCollectionId={patternCollection.id}
            />
          </div>
          <div className="w-50 bt pt2">
            <ModelExportAcousticPerf
              t={t}
              patternId={pattern.id}
              patternTitle={pattern.title}
              patternCollectionTitle={patternCollection.title}
              patternConfig={patternConfig}
            />
          </div>
        </div>
        <div className="mb6">
          <div className="f4 b mb2">{t("pdf:pdfLabelMakerContact")}</div>
          <div className="f7">
            <div className="b mb02">{t("pdf:pdfLabelTechnicalSupport")}</div>
            obersound@ober-surfaces.com
          </div>
        </div>

        <ModelExportFooter />
      </div>
    </div>
  );
};

export default ModelExportPdf;



// WEBPACK FOOTER //
// ./src/components/ModelExportPdf.js